// статический класс вспомогательных функций
import {
    APP,
} from '_pixiSrc/globals';
import Sprite from '_pixiSrc/display/Sprite';

import {
    Utils,
} from '_pixiSrc/Utils';
import BitmapText from '_pixiSrc/display/BitmapText';

import {
    ALIGN,
    VALIGN,
} from '_pixiSrc/globals';
import Fonts from './Fonts';

BitmapText.LINES_DELIMITER = '\\n';

'use strict';
// static class of auxiliary functions
// a set of auxiliary methods, although not all of them are used in this game.
const Static = {

    randomInteger(min, max) {
        let rand = min - 0.5 + Math.random() * (max - min + 1);
        rand = Math.round(rand);
        return rand;
    },

    // universal check function, whether two segments intersect with coordinates given by extreme points
    isVectorsCrosses(x1, y1, x2, y2, x3, y3, x4, y4) {
        function calculateVector(aX, aY, bX, bY) {
            return aX * bY - bX * aY;
        }

        const vectors = {
            v1: calculateVector(x4 - x3, y4 - y3, x1 - x3, y1 - y3),
            v2: calculateVector(x4 - x3, y4 - y3, x2 - x3, y2 - y3),
            v3: calculateVector(x2 - x1, y2 - y1, x3 - x1, y3 - y1),
            v4: calculateVector(x2 - x1, y2 - y1, x4 - x1, y4 - y1),
        };

        if (vectors.v1 * vectors.v2 < 0 && vectors.v3 * vectors.v4 < 0) {
            return true;
        }
    },

    writeText(parent, txt, font, x = 0, y = 0, options = {}) {
        let text;


        let asset;
        const f = Fonts[font];

        try {
            asset = APP.library.getAsset(`fonts/${font}`);
        } catch (e) { }

        if (!f) {
            return;
        }

        if (asset) {
            text = new BitmapText(f, asset);
        } else {
            const pages = [];


            let counter = 1;
            do {
                asset = null;
                try {
                    asset = APP.library.getAsset(`fonts/${font}_p${counter}`);
                } catch (e) { }

                if (asset) {
                    pages.push(asset);
                }
                counter++;
            } while (asset);

            text = new BitmapText(f, ...pages);
        }

        parent.addChild(text);

        text.x = x;
        text.y = y;

        text.charSpacing = options.charSpacing || 0;
        text.lineSpacing = options.lineSpacing || 0;
        text.rotation = options.rotation || 0;
        text.align = options.align || ALIGN.CENTER;
        text.valign = options.valign || VALIGN.MIDDLE;
        if (options.scale) {
            text.scale._x = options.scale;
            text.scale._y = options.scale;
        }
        if (options.width) {
            text.maxWidth = options.width;
        }

        if (options.spaceDivider) {
            let digitsCounter = 0;
            const arr = [];
            (function write(string) {
                const symbol = string.pop();

                if (!isNaN(+symbol)) {
                    digitsCounter++;
                } else { digitsCounter = 0; }

                arr.unshift(symbol);

                if (digitsCounter && digitsCounter % 3 === 0) {
                    arr.unshift(' ');
                }
                if (string.length) {
                    write(string);
                }
            }((`${txt}`).split('')));

            text.write(arr.join('').trim());
        } else {
            text.write(txt);
        }

        return text;
    },

    writeNativeText(parent, txt, font, x = 0, y = 0, options = {}) {
        const style = {
            fontFamily: font || 'Arial',
            fontSize: `${options.size || 14}px`,
            fontStyle: options.style || 'normal',
            fontWeight: options.weight || 'normal',
            fill: options.fill || 'white',
            stroke: options.stroke || '#000000',
            strokeThickness: options.strokeThickness || 0,
            dropShadow: options.dropShadow || false,
            dropShadowColor: options.dropShadowColor || '#000000',
            dropShadowAngle: options.dropShadowAngle || 0,
            dropShadowDistance: options.dropShadowDistance || 0,
            dropShadowBlur: options.dropShadowBlur || 0,
            wordWrap: options.wordWrap || false,
            wordWrapWidth: options.wordWrapWidth || 0,
            align: options.alignText || 'left',
            letterSpacing: options.letterSpacing || 0,
            padding: options.padding || 0,
        };

        txt += '';

        const tmp = txt.split('\\n');
        txt = tmp.join('\n');

        if (options.spaceDivider) {
            let digitsCounter = 0;
            const arr = [];
            (function write(string) {
                const symbol = string.pop();

                if (!isNaN(+symbol)) {
                    digitsCounter++;
                } else {
                    digitsCounter = 0;
                }

                arr.unshift(symbol);

                if (digitsCounter && digitsCounter % 3 === 0) {
                    arr.unshift(' ');
                }
                if (string.length) {
                    write(string);
                }
            }((`${txt}`).split('')));

            txt = arr.join('').trim();
        }

        const view = new PIXI.Text(txt, style);

        view.position.set(x, y);
        view.rotation = options.rotation || 0;

        if (options.align === ALIGN.RIGHT) {
            view.anchor.x = 1;
        } else if (options.align === ALIGN.LEFT) {
            view.anchor.x = 0;
        } else {
            view.anchor.x = 0.5;
        }

        if (options.valign === VALIGN.BOTTOM) {
            view.anchor.y = 0;
        } else if (options.valign === VALIGN.TOP) {
            view.anchor.y = 1;
        } else {
            view.anchor.y = 0.5;
        }

        parent.addChild(view);

        return view;
    },

    /**
   * @name setScaleToFitWidthNativeText
   * @param {PIXI.TEXT} pixiText pixi text object for scale to fit
   * @param {Number} width maximum width for pixi text
   * @param {Number} minScale minimum scale for text
   * @param {Number} maxScale maximum scale for text
   * @param {Array}  [otherObjects=[]] array of other sprite or text for resize as current text
   */
    setScaleToFitWidthNativeText(pixiText, width, minScale, maxScale, otherObjects = []) {
        if (pixiText instanceof PIXI.Text) {
            let newScale = width / pixiText.width;

            if (minScale && newScale < minScale) {
                // set new scale as min scale if newScale is less than minScale
                newScale = minScale;
            } else if (maxScale && newScale > maxScale) {
                // set new scale as max scale if newScale is more than maxScale
                newScale = maxScale;
            }
            pixiText.scale.set(newScale);
            for (let i = 0; i < otherObjects.length; i++) {
                otherObjects[i].scale.set(newScale);
            }
            return pixiText;
        }
    },

    // function measurement FPS in the console, you need to hang on a tick logFPS.onTick ();
    logFPS: (function () {
        let seconds = 0;

        let counter = 0;

        let isAllowed = true;

        return {
            onTick() {
                if (!isAllowed) {
                    return;
                }

                const newSeconds = new Date().getSeconds();
                if (seconds != newSeconds) {
                    seconds = newSeconds;
                    counter = 0;
                } else {
                    counter++;
                }
            },
            start() {
                isAllowed = true;
            },
            stop() {
                isAllowed = false;
            },
        };
    }()),

    // randomization function for a one-dimensional array of any length
    randomizeArray(incomeArray) {
        incomeArray = incomeArray.slice();
        const resArr = [];

        while (incomeArray.length) {
            resArr.push(incomeArray.splice(Helper.randomInteger(0, incomeArray.length - 1), 1)[0]);
        }

        return resArr;
    },

    // function emulator "shaking" of the screen or an individual sprite
    shakeElement(element, duration = 20, strength = 5, repeatNumber = 1, delayBetweenRepeat = 0, callback = () => { }) {
        const arr = Static.randomizeArray([1, -1, 0, 0]);

        const arr2 = Static.randomizeArray([1, -1, 0, 0]);

        element.moveBy(arr[0] * strength, arr2[0] * strength, duration, null, () => {
            element.moveBy(arr[1] * strength, arr2[1] * strength, duration, null, () => {
                element.moveBy(arr[2] * strength, arr2[2] * strength, duration, null, () => {
                    element.moveBy(arr[3] * strength, arr2[3] * strength, duration, null, () => {
                        if (repeatNumber > 0) {
                            setTimeout(() => {
                                Static.shakeElement(element, duration, strength, repeatNumber - 1, delayBetweenRepeat, callback);
                            }, delayBetweenRepeat);
                        } else {
                            callback();
                        }
                    });
                });
            });
        });
    },

    // casting an object to an array, all non-numeric properties are discarded
    objectToArray(obj) {
        obj.length = Object.keys(obj).length;
        const res = Array.prototype.slice.call(obj);
        return res.filter(e => (typeof e !== 'undefined'));
    },

    // The search function of tangents (inner and outer) for two circles
    // a, b - {x:number, y:number, r:number}
    // return: new Array (4), where 0 and 3 are outer tangents, and 1 and 2 are internal
    // each element: {a: number, b: number, c: number}, where the numbers are the coefficients of the equation Ax + By + X = 0
    tangents(a, b) {
        const EPS = Number.MIN_VALUE;
        const ans = [];
        const c = {
            x: b.x - a.x,
            y: b.y - a.y,
        };
        const z = Math.pow(c.x, 2) + Math.pow(c.y, 2);

        for (let i = -1; i <= 1; i += 2) {
            for (let j = -1; j <= 1; j += 2) {
                const r = (b.r * j) - (a.r * i);

                let d = z - Math.pow(r, 2);

                if (d >= -EPS) {
                    d = Math.sqrt(Math.abs(d));
                    const ln = {
                        a: (c.x * r + c.y * d) / z,
                        b: (c.y * r - c.x * d) / z,
                        c: a.r * i,
                    };
                    ln.c -= ln.a * a.x + ln.b * a.y;
                    ans.push(ln);
                }
            }
        }
        return ans;
    },

    // obtaining the base vector
    // requires box2d
    getBasicVector() {
        return new b2Vec2(1, 0);
    },

    // function allows to obtain an angle to the vector relative to the base vector vec1 (random)
    // input format: {a: number, b: number, c: number} for an equation of the form Ax + By + C = 0
    // or {x: number, y: number} for the vector
    // requires box2d
    angleToVector(tangents) {
        const vec1 = Static.getBasicVector();
        vec1.Normalize();
        if (tangents.a) { // check the input data format
            const vec2 = new b2Vec2(-tangents.b, tangents.a);
        } else {
            const vec2 = new b2Vec2(tangents.x, tangents.y);
        }
        vec2.Normalize();

        // gameScreen.addChild(Static.createLineFromVector({a: 0, b: -1, c: 0}, 'gray'));

        const sign = vec2.y > 0 ? 1 : -1;
        const angle = Math.acos(vec1.x * vec2.x + vec1.y * vec2.y) * sign;
        return Static.normalizeAngle(angle);
    },

    // function of rotation of a vector by a given angle
    // requires box2d
    rotateVector(vector, angle) {
        const rotated_vector = new b2Vec2();
        rotated_vector.x = vector.x * Math.cos(angle) - vector.y * Math.sin(angle);
        rotated_vector.y = vector.x * Math.sin(angle) + vector.y * Math.cos(angle);
        return rotated_vector;
    },

    // function of obtaining the length of a vector
    // requires box2d
    vectorLength(x1, y1, x2, y2) {
        return b2Math.SubtractVV(new b2Vec2(x1, y1), new b2Vec2(x2, y2)).Length();
    },

    // function leads to an angle to the interval from 0 to 2P
    normalizeAngle(a) {
        a = +a;
        if (typeof a !== 'number' || isNaN(a)) {
            throw new TypeError('Invalid input parameter type: requires number!');
        }
        a -= Math.PI * 2 * Math.floor(a / (Math.PI * 2));
        return (a < 0) ? (a + Math.PI * 2) : a;
    },

    // receives an angle between two vectors
    angleBetweenVectors(anglesArr) {
        const normalized = Static.normalizeAngleInterval(anglesArr);
        if (Array.isArray(normalized[0])) {
            return Math.abs(normalized[0][0] - normalized[0][1]);
        }
        return Math.abs(normalized[0] - normalized[1]);
    },

    // the function checks the angle between two vectors specified as an angle relative to the normal
    // if the resulting angle is> 180, then it unfolds it so that it is less than 180
    normalizeAngleInterval(anglesArr) {
        if (!Array.isArray(anglesArr)) {
            throw new TypeError('Invalid input parameter type: an array is required');
        }
        if (typeof anglesArr[0] !== 'number' || isNaN(anglesArr[0])) {
            throw new ReferenceError('An array must contain at least one number');
        }

        if (typeof anglesArr[1] !== 'number' || isNaN(anglesArr[1])) {
            anglesArr[1] = anglesArr[0];
        }

        const e1 = Static.normalizeAngle(anglesArr[0]);

        const e2 = Static.normalizeAngle(anglesArr[1]);

        const angle = Math.abs(e1 - e2);

        const output = [];

        const max = Math.max(e1, e2);

        const min = Math.min(e1, e2);

        if (angle > Math.PI) {
            output.push(max - Math.PI * 2);
            output.push(min);
        } else {
            output.push(min);
            output.push(max);
        }

        return output;
    },

    // function normalizes angles in a two-dimensional array
    normalizeAngleIntervals(arr) {
        const result = [];
        for (let i = 0; i < arr.length; i++) {
            const normalized = Static.normalizeAngleInterval(arr[i]);
            if (Array.isArray(normalized[0])) {
                normalized.forEach((e) => {
                    result.push(e);
                });
            } else {
                result.push(normalized);
            }
        }
        return result;
    },

    /* the function sweeps the intersection of arrays and returns a new array of arrays that excludes intersections */
    /* input: arr1: [[], [], ...], arr2: [[], [], ...] */
    breakAnArray: function me(arr1, arr2) {
        if (!Utils.isArray(arr1) || !Utils.isArray(arr2)) {
            throw new ReferenceError('The input parameters of the array stakeout function must be arrays!');
        }

        arr1 = arr1.slice();
        arr2 = arr2.slice();

        // filtering incoming arrays
        for (let i = 0; i < arr1.length; i++) {
            let e = arr1[i];
            if (e[0] === undefined || e[1] === undefined) {
                arr1.splice(i, 1);
                i--;
            } else {
                e = e.sort((a, b) => +a - +b);
            }
        }

        for (let i = 0; i < arr2.length; i++) {
            let e = arr2[i];
            if (e[0] === undefined || e[1] === undefined) {
                arr2.splice(i, 1);
                i--;
            } else {
                e = e.sort((a, b) => +a - +b);
            }
        }

        outer: for (let i = 0; i < arr1.length; i++) {
            for (let j = 0; j < arr2.length; j++) {
                if (arr1.length === 0) {
                    return [];
                }
                if (arr2[j][0] <= arr1[i][0]) { // if the left boundary is <= left
                    if (arr2[j][1] <= arr1[i][0]) {
                        continue;
                    } // right border <left, i.e. the whole interval <
                    else { // правая граница > левой
                        if (arr2[j][1] < arr1[i][1]) { // if the right boundary of <right
                            arr1.splice(i, 1, [arr2[j][1], arr1[i][1]]);
                            arr1 = me(arr1, arr2); // recursive call with a new, "truncated" array
                        } else { // if the right boundary> = right, i.e. The interval completely captures the original array
                            arr1.splice(i, 1);
                            i--;
                            continue outer;
                        }
                    }
                } else if (arr2[j][0] >= arr1[i][1]) { // if the left boundary is> right, i.e. the whole interval>
                    continue;
                } else { // there was a case when the left border> right and <left
                    if (arr2[j][1] < arr1[i][1]) { // the whole interval is inside the original
                        arr1.push([arr2[j][1], arr1[i][1]]);
                        arr1.splice(i, 1, [arr1[i][0], arr2[j][0]]);
                        arr1 = me(arr1, arr2);
                    } else { // if the right border> = right
                        arr1.splice(i, 1, [arr1[i][0], arr2[j][0]]);
                        arr1 = me(arr1, arr2);
                    }
                }
            }
        }

        // final sorting of intervals
        arr1 = arr1.sort((a, b) => {
            const e1 = (a[0] + a[1]) / 2;
            const e2 = (b[0] + b[1]) / 2;
            return e1 - e2;
        });

        // now combine adjacent intervals
        for (let i = 1; i < arr1.length; i++) {
            if (arr1[i - 1][1] === arr1[i][0]) {
                arr1[i - 1][1] = arr1[i][1];
                arr1.splice(i, 1);
                i--;
            }
        }
        return arr1;
    },

    // function allows you to get intersections of any number of intervals
    // input parameters: two-dimensional arrays
    crossAnArray(arr1, arr2) {
        const substr = Static.breakAnArray(arr1, arr2);
        return Static.breakAnArray(arr1, substr);
    },

    // breaks corners, previously normalizing them
    breakAnAnglesArray(arr1, arr2) {
        arr1 = Static.normalizeAngleIntervals(arr1);
        arr2 = Static.normalizeAngleIntervals(arr2);

        return Static.breakAnArray(arr1, arr2);
    },

    /**  TEST FUNCTIONS  * */

    // draw a corner line
    // requires box2d
    createLineFromAngle(obj, angle, color) {
        const vector = Static.rotateVector(Static.getBasicVector(), angle);
        const x1 = obj.x;
        const y1 = obj.y;
        const x2 = vector.x * 10000;
        const y2 = vector.y * 10000;
        const line = new Graphics.line(x1, y1, x2, y2);
        line.color = color || 'black';
        return line;
    },

    // Draw a line through the vector
    createLineFromVector(obj, vector, color) {
        const x1 = obj.x;
        const y1 = obj.y;
        const x2 = vector.x * 10000;
        const y2 = vector.y * 10000;
        const line = new Graphics.line(x1, y1, x2, y2);
        line.color = color || 'black';
        return line;
    },
};

export default Static;
